export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-4">随时随地，畅享观影</h2>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-6">
              51影院全面适配移动端浏览器，无需下载APP，打开手机浏览器输入网址即可访问。全站响应式设计，在小屏幕上也能获得流畅的高清观影体验。支持横竖屏切换，适配各类移动设备。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-200/50 border border-background-200/60">
                <i className="ri-smartphone-line text-primary-400 text-lg"></i>
                <span className="text-sm text-foreground-300">手机浏览器直接访问</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-200/50 border border-background-200/60">
                <i className="ri-tablet-line text-primary-400 text-lg"></i>
                <span className="text-sm text-foreground-300">平板大屏体验</span>
              </div>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <div className="relative w-[240px] h-[480px] rounded-2xl overflow-hidden border-4 border-background-300/50 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20showing%20movie%20streaming%20app%20interface%20with%20dark%20theme%20and%20golden%20accents%2C%20film%20poster%20thumbnails%2C%20clean%20modern%20UI%20design%2C%20cinema%20app%20mockup%2C%20no%20text%2C%20elegant%20layout&width=480&height=960&seq=app-mockup-cinema&orientation=portrait"
                alt="51影院移动端体验"
                title="51影院 - 手机观影界面"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}